import { lazy } from 'react';

const TimeZone = lazy(() => import('../pages/TimeZone/TimeZone'));
const Pomodoro = lazy(() => import('../pages/Pomodoro/Pomodoro'));
const DailyPlanner = lazy(() => import('../pages/DailyPlanner/DailyPlanner'));
const WorldTimer = lazy(() => import('../pages/WorldTimer/WorldTimer'));
const Timer = lazy(() => import('../pages/Timer/Timer'));
const StopWatch = lazy(() => import('../pages/StopWatch/StopWatch'));

export const PagesTabsObj = [
            {
                name : "timezone",
                component :  <TimeZone />,
                data : "",
                key : 1
            },
            {
                name : "pomodoro",
                component :  <Pomodoro />,
                data : "",
                key : 2
            },
            {
                name : "dailyplanner",
                component :  <DailyPlanner />,
                data : "",
                key : 3
            },
            {
                name : "worldtimer",
                component :  <WorldTimer />,
                data : "",
                key : 4
            },
            {
                name : "timer",
                component :  <Timer />,
                data : "",
                key : 5
            },
            {
                name : "stopwatch",
                component :  <StopWatch />,
                data : "",
                key : 6
            },
        
        ]
     
    
 


